import { Input, InputProps } from 'antd';
import './style.scss';

const InputBase = (props: InputProps) => {
  return <Input className="input-base" {...props} />;
};

export default InputBase;
